import cx from "classnames";

type PriceProps = {
  price?: number;
  className?: string;
};

export default function Price({ price, className }: PriceProps) {
  const [currentPrice, cents] = String(price).replace(",", ".").split(".");
  const classNames = cx("leading-none py-1 min-w-32", className);

  return (
    <div className={classNames}>
      <strong className="inline-block">
        <span className="pr-1 align-top text-base font-bold leading-none">
          R$
        </span>
        <span style={{ lineHeight: 0.75 }} className="text-3xl">
          {currentPrice}
        </span>
        <div className="inline-flex flex-col items-start justify-start align-top">
          <sup className="inline-block pl-px pt-2 align-top text-base font-bold leading-none tracking-wide">
            {cents ? `,${cents}` : ",00"}
          </sup>
          <sub className="text-base font-bold tracking-wide opacity-50">
            /mês
          </sub>
        </div>
      </strong>
    </div>
  );
}
